import axios, { AxiosError } from 'axios'

import { createRequestException } from '../../helpers/requestException'
import { createJbErrorMessageMappedByHttpStatusEnum } from '../../helpers/jb-error'
import { AxiosResponse } from 'axios'
import { sanitizeAddress } from '../../helpers/address'

interface ViaCepResponse {
  cep: string
  logradouro: string
  complemento: string
  unidade: string
  bairro: string
  localidade: string
  uf: string
  estado: string
  regiao: string
  ibge: string
  gia: string
  ddd: string
  siafi: string
}

interface ViaCepResponseError {
  erro: true
}

const translateViaCepResponse = (response: ViaCepResponse): CepResponse => ({
  code: response.cep,
  address: response.logradouro,
  city: response.localidade,
  complement: response.complemento,
  district: response.bairro,
  state: response.uf,
  uf: response.uf,
  region: response.regiao,
  ibge: response.ibge,
  gia: response.gia,
  ddd: response.ddd,
  siafi: response.siafi,
})

export const getCepByViaCep = async (cep: string): Promise<CepResponse> => {
  const viaCepResponse: AxiosResponse<ViaCepResponse | ViaCepResponseError> =
    await axios
      .get(`https://viacep.com.br/ws/${cep}/json/`)
      .catch(createRequestException)
      .catch(createJbErrorMessageMappedByHttpStatusEnum)

  if ((viaCepResponse.data as ViaCepResponseError).erro) {
    throw new AxiosError('CEP not found')
  }

  return translateViaCepResponse(viaCepResponse.data as ViaCepResponse)
}

interface ApiCepResponse {
  status: number
  code: string
  state: string
  city: string
  district: string
  address: string
}

interface ApiCepResponseError {
  message: string
  ok: false
  status: number
  statusText: string
}

const translateApiCepResponse = (response: ApiCepResponse): CepResponse => ({
  code: response.code,
  address: response.address ? sanitizeAddress(response.address) : '',
  city: response.city,
  complement: '',
  district: sanitizeAddress(response.district),
  state: response.state,
  uf: response.state,
  region: '',
  ibge: '',
  gia: '',
  ddd: '',
  siafi: '',
})

export const getCepByApiCep = async (cep: string): Promise<CepResponse> => {
  const apiCepResponse: AxiosResponse<ApiCepResponse | ApiCepResponseError> =
    await axios
      .get(`https://ws.apicep.com/cep.json?code=${cep}`)
      .catch(createRequestException)
      .catch(createJbErrorMessageMappedByHttpStatusEnum)

  // checks if APiCepResponseError
  if ((apiCepResponse.data as ApiCepResponseError).ok === false) {
    throw new AxiosError('CEP not found')
  }

  return translateApiCepResponse(apiCepResponse.data as ApiCepResponse)
}

export interface CepResponse {
  code: string
  address: string
  city: string
  complement: string
  district: string
  state: string
  uf: string
  region: string
  ibge: string
  gia: string
  ddd: string
  siafi: string
}
export const getCep = async (cep: string): Promise<CepResponse> => {
  try {
    return await getCepByApiCep(cep)
  } catch (e) {
    return await getCepByViaCep(cep)
  }
}
